import {
    faArrowRight,
    faCamera,
    faImage,
    faPen,
    faCheck
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Hidden,
    IconButton,
    Slide,
    TextField,
    Box,
    Typography
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { useEffect, forwardRef, useState, useRef } from 'react'
import { dateWithTime, imageToBase64 } from '../config'
import ImageDialog from './ImageDialog'
import ImageAstDialog from './ImageAstDialog'
import InputTextDialog from './InputTextDialog'
import {
    useAuth,
    useExecutionReportContext,
    useReportsContext,
    useUser,
    useAlertContext
} from '../context'
import { CameraModal, LoadingModal } from '../modals'
import AlertDialog from '../dialogs/AlertDialog'

const Transition = forwardRef(function Transition (props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const ReportDataDialog = ({
    open,
    handleClose,
    item,
    index,
    executionReport,
    gruposKeys,
    indexGroup,
    canEdit,
    onCancelLogout
}) => {
    const { userData } = useAuth()
    const { admin, isOperator, isUniversalChief } = useUser()
    const { saveItem } = useExecutionReportContext() || {}
    const { report } = useReportsContext()
    const { setConfirm } = useAlertContext()

    const currentUserId = userData?._id
    const userHasStarted = report?.ejecuciones?.some(
        (e) =>
            (e.userId?._id || e.userId)?.toString() === currentUserId?.toString() &&
            e.termino === null
    )
    const shouldBeInteractive = (isOperator && !isUniversalChief) && userHasStarted

    const [, setIndexGroupCache] = useState()
    const [message, setMessage] = useState('')
    const [messages, setMessages] = useState([])

    const [unidad, setUnidad] = useState('')
    const [openImageDialog, setOpenImageDialog] = useState(false)
    const [openImageAstDialog, setOpenImageAstDialog] = useState(false)
    const [imagePreview, setImagePreview] = useState('')
    const [openLoadingModal, setOpenLoadingModal] = useState(false)
    const [openInputTextDialog, setOpenInputTextDialog] = useState(false)
    const [astList, setAstList] = useState([])
    const [, setAst] = useState(false)
    const [totalMessagesWithPictures, setPicturesOfItem] = useState(0)
    const [indexKey, setIndexKey] = useState()
    const [, setIsEdited] = useState(false)
    const [openCamera, setOpenCamera] = useState(false)
    const [galleryImageToEdit, setGalleryImageToEdit] = useState(null)
    const [, setCapturedImageBase64] = useState(null)
    const [unidadError, setUnidadError] = useState(false)
    const [unidadHelperText, setUnidadHelperText] = useState('')
    const [alertOpen, setAlertOpen] = useState(false)
    const [alertTitle, setAlertTitle] = useState('')
    const [alertMessage, setAlertMessage] = useState('')

    const [editingIndex, setEditingIndex] = useState(null)
    const [editingText, setEditingText] = useState('')

    // Actually, useRef is imported. Let's use useRef properly.
    const commitsScrollRef = useRef(null) // Renaming to avoid conflict if any

    const handleStartEditMessage = (idx, currentContent) => {
        setEditingIndex(idx)
        setEditingText(currentContent || '')
    }

    const handleSaveEditMessage = (idxToEdit) => {
        if (!editingText.trim()) return
        setIsEdited(true)
        const updatedMessages = messages.map((m, i) => {
            if (i === idxToEdit) {
                return { ...m, content: editingText.trim() }
            }
            return m
        })
        setMessages(updatedMessages)
        if (item) {
            item.messages = updatedMessages
        }
        if (executionReport && executionReport.group && executionReport.group[indexGroup]) {
            executionReport.group[indexGroup][index] = item
        }
        setEditingIndex(null)
        setEditingText('')
    }

    useEffect(() => {
        if (indexGroup) {
            setIndexGroupCache(indexGroup)
        }
    }, [indexGroup])

    useEffect(() => {
        if (unidad) {
            // if (item && item.partnumberUtl === 'HOROMETRO EQUIPO') {
            //     executionReport.group[indexGroup][index].unidadData = Number(unidad) * 3600
            // } else {
            //     executionReport.group[indexGroup][index].unidadData = unidad
            // }
        }
    }, [unidad])

    useEffect(() => {
        if (item) {
            gruposKeys.map((k, n) => {
                if (k.data === indexGroup) {
                    setIndexKey(n)
                }
            })
            if (executionReport) {
                if (executionReport.astList) {
                    setAstList(executionReport.astList)
                }
            }
            if (
                (item.partnumberUtl === 'HOROMETRO EQUIPO' || item.partnumber_utl === 'HOROMETRO EQUIPO') &&
				(item.unidadData !== null && item.unidadData !== undefined)
            ) {
                setUnidad(Number(item.unidadData) / 3600)
            } else {
                setUnidad(
                    item.unidadData !== null && item.unidadData !== undefined
                        ? item.unidadData
                        : ''
                )
            }
            if (item.messages) {
                const total = []
                item.messages.forEach(async (m, i) => {
                    console.log(m)
                    if (m) {
                        if (m.urlBase64) {
                            total.push(m)
                        }
                        if (i === item.messages.length - 1) {
                            setPicturesOfItem(total.length + 1)
                            setMessages(item.messages)
                        }
                    }
                })

                setTimeout(() => {
                    if (commitsScrollRef.current) {
                        commitsScrollRef.current.scrollTop =
							commitsScrollRef.current.scrollHeight
                    }
                }, 100)
            }
        }
    }, [item])

    useEffect(() => {
        if (messages.length > 0 && item) {
            let haveMessage = false
            let haveClip = false
            const messagesCache = [...messages]
            console.log(messagesCache)
            messagesCache.forEach(async (mess, i) => {
                if (mess) {
                    if (mess.urlBase64 || mess.urlImageMessage) {
                        haveClip = true
                    }
                    if (
                        mess.content === 'Se indica estado ejecutado sin dejar mensajes'
                    ) {
                    } else {
                        haveMessage = true
                    }
                    if (i === messages.length - 1) {
                        item.haveMessage = haveMessage
                        item.haveClip = haveClip
                        item.messages = messagesCache
                        executionReport.group[indexGroup][index] = item
                    }
                }
            })
            setMessage('')
            setTimeout(() => {
                if (commitsScrollRef.current) {
                    commitsScrollRef.current.scrollTop =
						commitsScrollRef.current.scrollHeight
                }
            }, 50)
        }
    }, [messages, item])

    const changeUnidad = (value) => {
        if (value === '' || value === undefined || value === null) {
            setUnidad(value)
            setUnidadError(false)
            setUnidadHelperText('')
            return
        }

        const numericValue = parseFloat(value)
        if (isNaN(numericValue)) {
            setUnidad(value)
            setUnidadError(true)
            setUnidadHelperText('Ingrese un número válido')
            return
        }

        if (numericValue < 0) {
            setUnidad(value)
            setUnidadError(true)
            setUnidadHelperText('El valor debe ser positivo')
        } else {
            setUnidad(value)
            setUnidadError(false)
            setUnidadHelperText('')
        }
    }

    const inputMessage = (value) => {
        setMessage(value)
    }

    const upImage = () => {
        document.getElementById('foto').click()
    }

    const uploadImageReport = async (file) => {
        if (file) {
            const res = await imageToBase64(file)
            setGalleryImageToEdit(res)
            setOpenCamera(true)
        }
    }

    const saveMessage = async (image, messagePicture, url) => {
        if (message.length > 0 || messagePicture) {
            console.log(message)
            console.log('editnando execution')
            let totalImages = totalMessagesWithPictures
            if (image) {
                item.haveClip = true
                totalImages = totalImages + 1
                setPicturesOfItem(totalImages)
            }
            let m
            if (messagePicture) {
                m = messagePicture
            } else {
                m = message
            }
            const findMessage = messages.filter((mess) => {
                if (messagePicture === mess.content) return mess
            })
            if (findMessage[0]) {
                messages.forEach((message, i) => {
                    if (message.content === findMessage[0].content) {
                    }
                })
            } else {
                const messageData = {
                    id: Date.now(),
                    namePicture: url
                        ? `${indexKey}_Tarea_${index + 1}_Foto_${totalImages}`
                        : null,
                    content: m,
                    name: `${userData.name} ${userData.lastName}`,
                    user: userData._id,
                    urlBase64: image,
                    urlImageMessage: url
                }
                const messagesOk = []
                messages.forEach((m) => {
                    if (m) {
                        messagesOk.push(m)
                    }
                })
                const messagesCache = [...messagesOk]
                messagesCache.push(messageData)
                setMessages(messagesCache)
            }
        }
    }

    const openImage = (image) => {
        setImagePreview(image)
        setOpenImageDialog(true)
    }

    const openCameraToAst = () => {
        setOpenCamera(true)
    }

    const closeCamera = () => {
        setOpenCamera(false)
    }

    const handleCloseImage = () => {
        setOpenImageDialog(false)
    }

    const handleCloseText = () => {
        setOpenInputTextDialog(false)
    }

    const handleCloseAstImage = () => {
        setOpenImageAstDialog(false)
    }

    const disable = () => {
        document.onkeydown = (e) => {
            return false
        }
    }

    const deleteMessage = (index) => {
        setConfirm(
            'Confirmar Borrado',
            '¿Confirma borrar el mensaje?',
            () => {
                setIsEdited(true)
                const messagesNew = []
                messages.forEach((m, i) => {
                    if (index === i) {
                        null
                    } else {
                        messagesNew.push(m)
                    }
                    if (i === messages.length - 1) {
                        setMessages(messagesNew)
                        item.messages = messagesNew
                        if (item.messages.length === 0) {
                            item.haveMessage = false
                            item.haveClip = false
                        } else {
                            let haveClip = false
                            let haveMessage = false
                            item.messages.forEach((mess, idx) => {
                                console.log(mess)
                                if (
                                    mess.content === 'Se indica estado ejecutado sin dejar mensajes'
                                ) {
                                } else {
                                    haveMessage = true
                                }
                                if (mess.urlBase64 || mess.urlImageMessage) {
                                    haveClip = true
                                }
                                console.log('Clip', haveClip)
                                if (idx === item.messages.length - 1) {
                                    item.haveClip = haveClip
                                    item.haveMessage = haveMessage
                                }
                            })
                        }
                    }
                })
            }
        )
    }

    const close = () => {
        if (
            JSON.stringify(messages) ===
			JSON.stringify(item.messages ? item.messages : [])
        ) {
            if (onCancelLogout) {
                onCancelLogout()
            } else {
                handleClose()
            }
        } else {
            setConfirm(
                'Descartar Cambios',
                'Si cierra la ventana sin guardar los nuevos mensajes, éstos se borrarán. ¿Desea continuar?',
                () => {
                    if (onCancelLogout) {
                        onCancelLogout()
                    } else {
                        handleClose()
                    }
                    if (!item.messages || item.messages.length === 0) {
                        item.haveMessage = false
                        item.haveClip = false
                    }
                }
            )
        }
    }

    const handleOpenCamera = (e) => {
        if (e) e.preventDefault()
        setOpenCamera(true)
    }
    const handleCloseCamera = (e) => {
        if (e) e.preventDefault()
        setOpenCamera(false)
        setGalleryImageToEdit(null)
    }

    const handleImageCapture = (imageBase64, commentText) => {
        setCapturedImageBase64(imageBase64)
        const comment = commentText && commentText.trim() !== '' ? commentText : `Imagen ${Date.now()}`
        saveMessage(imageBase64, comment, null)
        setGalleryImageToEdit(null)
    }

    const handleSave = (isExecuting) => {
        if (unidadError) {
            setAlertTitle('Error de Validación')
            setAlertMessage(
                'Por favor, corrija los errores en el formulario antes de guardar.'
            )
            setAlertOpen(true)
            return
        }

        const currentMessages = [...(messages || [])]
        let hasNewMessage = false

        if (message.length > 0) {
            const newMessageData = {
                id: Date.now(),
                content: message,
                name: `${userData.name} ${userData.lastName}`,
                user: userData._id,
                urlBase64: null,
                urlImageMessage: null
            }
            currentMessages.push(newMessageData)
            hasNewMessage = true
            setMessage('')
        }

        let finalValue =
			unidad !== '' && unidad !== null && unidad !== undefined
			    ? parseFloat(unidad)
			    : null
        if (item.partnumberUtl === 'HOROMETRO EQUIPO' && finalValue !== null) {
            finalValue = finalValue * 3600
        }

        const itemToSave = {
            ...item,
            unidadData: finalValue,
            saved: true
        }

        const filteredMessages = currentMessages.filter(
            (msg) => msg.content !== 'Se indica estado ejecutado sin dejar mensajes'
        )
        let finalMessages = filteredMessages

        if (!isExecuting) {
            itemToSave.isChecked = true
            itemToSave.isWarning = true
            if (filteredMessages.length === 0) {
                finalMessages = [
                    {
                        content: 'Marcada como NO ejecutada sin dejar mensajes',
                        id: Date.now(),
                        name: `${userData.name} ${userData.lastName}`,
                        namePicture: null,
                        user: userData._id
                    }
                ]
            }
        } else {
            itemToSave.isChecked = true
            itemToSave.isWarning = false
        }

        // Compute flags based on messages
        let haveMessage = false
        let haveClip = false
        finalMessages.forEach((msg) => {
            if (msg.urlBase64 || msg.urlImageMessage) {
                haveClip = true
            }
            if (
                msg.content &&
				msg.content !== 'Se indica estado ejecutado sin dejar mensajes' &&
				msg.content !== 'Marcada como NO ejecutada sin dejar mensajes'
            ) {
                haveMessage = true
            }
        })

        itemToSave.messages = finalMessages
        itemToSave.haveMessage = haveMessage
        itemToSave.haveClip = haveClip

        if (item.partnumberUtl === 'HOROMETRO EQUIPO' && finalValue !== null) {
            if (report) {
                report.hourMeter = finalValue
            }
        }

        saveItem(index, itemToSave, indexGroup, handleClose)
    }

    return (
        <Dialog
            open={open}
            onClose={close}
            TransitionComponent={Transition}
            keepMounted
            aria-describedby="alert-dialog-slide-description"
            sx={{
                '& .MuiDialog-container': {
                    '& .MuiPaper-root': {
                        width: '100%',
                        maxWidth: '500px'
                    }
                }
            }}
        >
            <div style={{ position: 'absolute', right: 50, top: 10 }}>
                <IconButton onClick={() => close()} style={{ position: 'fixed' }}>
                    <Close />
                </IconButton>
            </div>
            <DialogTitle style={{ marginTop: 10 }}>{item.taskdesc}</DialogTitle>
            <DialogContent>
                <div style={{ maxHeight: 100, overflowY: 'auto' }}>
                    <DialogContentText
                        id="alert-dialog-slide-description"
                        style={{ whiteSpace: 'pre-line' }}
                    >
                        {item.obs01} <br />
                    </DialogContentText>
                </div>
                {(item.unidad !== '*') &&

                    ((
                        item.unidad === '%' ||
                        item.unidad === '°C' ||
                        item.unidad === 'CM' ||
                        item.unidad === 'H' ||
                        item.unidad === 'KM' ||
                        item.unidad === 'KPA' ||
                        item.unidad === 'M' ||
                        item.unidad === 'MM' ||
                        item.unidad === 'N' ||
                        item.unidad === 'PSI' ||
                        item.unidad === 'RPM' ||
                        item.unidad === 'T' ||
                        item.unidad === 'V' ||
                        item.unidad === 'pulg'
                    )
                        ? <Grid container>
                            <Grid item sm={3}>
                                <div style={{ marginLeft: 24, marginBottom: 16 }}>
                                    <TextField
                                        id="standard-basic"
                                        label={item.unidad}
                                        variant="standard"
                                        type='number'
                                        value={unidad}
                                        onChange={(e) => { changeUnidad(e.target.value) }}
                                        disabled={!shouldBeInteractive}
                                        error={unidadError}
                                        helperText={unidadHelperText}
                                    />
                                </div>
                            </Grid>
                            <Grid item xl={4} lg={4} md={4} sm={4}>
                                <Grid container>
                                    <Grid item sm={12}>
                                        <div>
                                            {/* <p>Param. a Medir: <br /> {item.cantidad} {item.unidad}</p> */}
                                            <p>{item.partnumberUtl || item.partnumber_utl}</p>
                                        </div>
                                    </Grid>
                                    <Grid item xl={6} lg={6} md={6} sm={6}>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        : <Grid container>
                            <Grid item sm={4}>
                                <div style={{ marginLeft: 24, marginBottom: 16, padding: '0px 10px 0px 0px' }}>
                                    <h3>Ingrese valor</h3>
                                    <TextField
                                        id="standard-basic"
                                        label={item.unidad}
                                        variant="standard"
                                        type='number'
                                        value={unidad}
                                        onChange={(e) => { changeUnidad(e.target.value) }}
                                        disabled={!shouldBeInteractive}
                                        error={unidadError}
                                        helperText={unidadHelperText}
                                    />
                                </div>
                            </Grid>
                            <Grid item sm={6}>
                                <Grid container>
                                    <Grid item xl={6} lg={6} md={6} sm={6}>
                                        <div style={{ padding: '0px 10px 0px 10px' }}>
                                            <p>Cant. Utilizar: <br /> {item.cantidad} {item.unidad}</p>
                                            <p>{item.partnumberUtl || item.partnumber_utl}</p>
                                        </div>
                                    </Grid>
                                    <Grid item xl={6} lg={6} md={6} sm={6}>
                                        <div style={{ padding: '0px 10px 0px 10px' }}>
                                            <p>Tipo Rpto: <br /> {item.idtypeutlPartnumber || item.idtypeutl_partnumber}</p>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                <Box sx={{ mb: 2.5 }}>
                    <Box
                        sx={{
                            width: '100%',
                            height: 330,
                            border: '1px solid #e0e0e0',
                            borderRadius: '12px',
                            position: 'relative',
                            display: 'flex',
                            flexDirection: 'column',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                            bgcolor: '#fcfcfc',
                            overflow: 'hidden'
                        }}
                    >
                        {/* List area */}
                        <Box
                            id="commits"
                            ref={commitsScrollRef}
                            sx={{
                                flexGrow: 1,
                                overflowY: 'auto',
                                scrollBehavior: 'smooth',
                                p: 1.5,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1.5
                            }}
                        >
                            {messages.length === 0 ? (
                                <Typography variant="body2" sx={{ textAlign: 'center', color: '#999', py: 4 }}>No hay mensajes ni imágenes</Typography>
                            ) : (
                                messages.map((message, index) => {
                                    if (!message) return null

                                    let effectiveImgSrc = message?.urlBase64
                                    if (!effectiveImgSrc) {
                                        effectiveImgSrc = message.urlImageMessage
                                    }
                                    if (effectiveImgSrc && (effectiveImgSrc.includes('/undefined') || effectiveImgSrc.endsWith('undefined.jpg') || effectiveImgSrc === 'undefined')) {
                                        effectiveImgSrc = null
                                    }

                                    return (
                                        <Box
                                            key={message.id || index}
                                            sx={{
                                                position: 'relative',
                                                p: 1.5,
                                                borderRadius: '8px',
                                                border: '1px solid #e0e0e0',
                                                backgroundColor: '#ffffff',
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 1
                                            }}
                                        >
                                            {/* Permiso exclusivo: solo el operador autor del mensaje puede editar o eliminar (admin NO puede si no es autor) */}
                                            {shouldBeInteractive && message?.user && (userData?._id?.toString() === message.user?.toString() || userData?._id === message.user) && (
                                                <>
                                                    <IconButton
                                                        onClick={() => deleteMessage(index)}
                                                        title="Eliminar comentario"
                                                        sx={{
                                                            position: 'absolute',
                                                            top: 6,
                                                            right: 6,
                                                            p: 0.5,
                                                            color: '#777',
                                                            '&:hover': { color: '#ff1744' }
                                                        }}
                                                    >
                                                        <Close style={{ fontSize: 16 }} />
                                                    </IconButton>
                                                    <IconButton
                                                        onClick={() => {
                                                            if (editingIndex === index) {
                                                                setEditingIndex(null)
                                                            } else {
                                                                handleStartEditMessage(index, message.content)
                                                            }
                                                        }}
                                                        title="Editar comentario"
                                                        sx={{
                                                            position: 'absolute',
                                                            top: 32,
                                                            right: 6,
                                                            p: 0.5,
                                                            color: editingIndex === index ? '#1976d2' : '#777',
                                                            '&:hover': { color: '#1976d2' }
                                                        }}
                                                    >
                                                        <FontAwesomeIcon icon={faPen} style={{ fontSize: 13 }} />
                                                    </IconButton>
                                                </>
                                            )}

                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 4 }}>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', fontSize: '0.8rem', color: '#333' }}>
                                                    {message.name}
                                                </Typography>
                                                <Typography variant="caption" sx={{ color: '#888', fontSize: '0.7rem' }}>
                                                    {dateWithTime(message.id)}
                                                </Typography>
                                            </Box>

                                            {effectiveImgSrc && (
                                                <Box sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    bgcolor: '#f5f5f5',
                                                    borderRadius: '4px',
                                                    overflow: 'hidden',
                                                    maxHeight: '160px',
                                                    cursor: 'pointer',
                                                    border: '1px solid #eee'
                                                }}>
                                                    <img
                                                        src={effectiveImgSrc}
                                                        alt="Attachment"
                                                        style={{
                                                            maxHeight: '160px',
                                                            maxWidth: '100%',
                                                            objectFit: 'contain'
                                                        }}
                                                        onClick={() => openImage(effectiveImgSrc)}
                                                    />
                                                </Box>
                                            )}

                                            {editingIndex === index ? (
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                                                    <TextField
                                                        fullWidth
                                                        multiline
                                                        size="small"
                                                        value={editingText}
                                                        onChange={(e) => setEditingText(e.target.value)}
                                                        sx={{
                                                            '& .MuiInputBase-root': { fontSize: '0.85rem' }
                                                        }}
                                                    />
                                                    <IconButton
                                                        onClick={() => handleSaveEditMessage(index)}
                                                        color="success"
                                                        size="small"
                                                        title="Guardar cambios"
                                                    >
                                                        <FontAwesomeIcon icon={faCheck} />
                                                    </IconButton>
                                                    <IconButton
                                                        onClick={() => setEditingIndex(null)}
                                                        color="error"
                                                        size="small"
                                                        title="Cancelar edición"
                                                    >
                                                        <Close style={{ fontSize: 16 }} />
                                                    </IconButton>
                                                </Box>
                                            ) : (
                                                <Typography variant="body2" sx={{ color: '#444', fontSize: '0.85rem', whiteSpace: 'pre-line', mt: 0.5 }}>
                                                    {message.content}
                                                </Typography>
                                            )}
                                        </Box>
                                    )
                                })
                            )}
                        </Box>

                        {/* Input bar at the bottom */}
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            p: 1,
                            borderTop: '1px solid #e8e8e8',
                            bgcolor: '#ffffff'
                        }}>
                            {shouldBeInteractive && (
                                <Box sx={{ display: 'flex', flexGrow: 1, mr: 1 }}>
                                    <Hidden mdDown>
                                        <textarea
                                            disabled={!shouldBeInteractive}
                                            value={message}
                                            placeholder="Escribe un comentario..."
                                            style={{
                                                width: '100%',
                                                height: '36px',
                                                padding: '8px 12px',
                                                borderRadius: '18px',
                                                border: '1px solid #e0e0e0',
                                                resize: 'none',
                                                fontFamily: 'inherit',
                                                fontSize: '14px',
                                                outline: 'none',
                                                boxSizing: 'border-box',
                                                backgroundColor: '#f5f5f5'
                                            }}
                                            onChange={(e) => {
                                                inputMessage(e.target.value)
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' && !e.shiftKey) {
                                                    e.preventDefault()
                                                    saveMessage()
                                                }
                                            }}
                                        />
                                    </Hidden>
                                    <Hidden mdUp>
                                        <textarea
                                            disabled={!shouldBeInteractive}
                                            id="mobileTextArea"
                                            value={message}
                                            placeholder="Escribe un comentario..."
                                            style={{
                                                width: '100%',
                                                height: '36px',
                                                padding: '8px 12px',
                                                borderRadius: '18px',
                                                border: '1px solid #e0e0e0',
                                                resize: 'none',
                                                fontFamily: 'inherit',
                                                fontSize: '14px',
                                                outline: 'none',
                                                boxSizing: 'border-box',
                                                backgroundColor: '#f5f5f5'
                                            }}
                                            onClick={() => {
                                                setOpenInputTextDialog(true)
                                                const el = document.getElementById('mobileTextArea')
                                                if (el) el.blur()
                                            }}
                                            readOnly
                                        />
                                    </Hidden>
                                </Box>
                            )}

                            <Box sx={{ display: 'flex', gap: 0.5 }}>
                                {shouldBeInteractive && (
                                    <IconButton
                                        onClick={(e) => handleOpenCamera(e)}
                                        sx={{ color: '#be2e26', '&:hover': { bgcolor: 'rgba(190,46,38,0.08)' } }}
                                    >
                                        <FontAwesomeIcon icon={faCamera} />
                                    </IconButton>
                                )}

                                {shouldBeInteractive && (
                                    <IconButton
                                        onClick={(e) => {
                                            upImage(e)
                                            setAst(false)
                                        }}
                                        sx={{ color: '#be2e26', '&:hover': { bgcolor: 'rgba(190,46,38,0.08)' } }}
                                    >
                                        <FontAwesomeIcon icon={faImage} />
                                    </IconButton>
                                )}

                                {shouldBeInteractive && message.trim().length > 0 && (
                                    <IconButton
                                        onClick={() => saveMessage()}
                                        sx={{ color: '#4caf50', '&:hover': { bgcolor: 'rgba(76,175,80,0.08)' } }}
                                    >
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    </IconButton>
                                )}
                            </Box>

                            <input
                                autoComplete="off"
                                type="file"
                                id="foto"
                                accept="image/x-png,image/jpeg"
                                onChange={(e) => {
                                    uploadImageReport(e.target.files[0])
                                }}
                                hidden
                            />
                            {openCamera && (
                                <CameraModal
                                    open={openCamera}
                                    handleClose={handleCloseCamera}
                                    onImageCapture={handleImageCapture}
                                    initialImageSrc={galleryImageToEdit}
                                />
                            )}
                        </Box>
                    </Box>
                </Box>

                {shouldBeInteractive && (
                    <Grid container>
                        <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ textAlign: 'center', marginBottom: 10 }}
                        >
                            <Button
                                style={{ backgroundColor: '#D5CC41', color: '#fff' }}
                                onClick={() => {
                                    handleSave(false)
                                }}
                            >
								Guardar sin ejecutar
                            </Button>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ textAlign: 'center', marginBottom: 10 }}
                        >
                            <Button
                                style={{ backgroundColor: '#9ACF26', color: '#fff' }}
                                onClick={() => {
                                    handleSave(true)
                                }}
                            >
								Guardar ejecutado
                            </Button>
                        </Grid>
                    </Grid>
                )}
            </DialogContent>

            {openImageDialog && (
                <ImageDialog
                    open={openImageDialog}
                    image={imagePreview}
                    handleClose={handleCloseImage}
                />
            )}
            {openImageAstDialog && (
                <ImageAstDialog
                    open={openImageAstDialog}
                    images={astList}
                    handleClose={handleCloseAstImage}
                    setIsEdited={setIsEdited}
                />
            )}
            {openInputTextDialog && (
                <InputTextDialog
                    open={openInputTextDialog}
                    handleClose={handleCloseText}
                    saveMessage={saveMessage}
                    message={message}
                    inputMessage={inputMessage}
                />
            )}
            {openLoadingModal && (
                <LoadingModal
                    open={openLoadingModal}
                    withProgress={false}
                    loadingData={'Cargando imágen'}
                />
            )}

            <AlertDialog
                open={alertOpen}
                title={alertTitle}
                message={alertMessage}
                onClose={() => setAlertOpen(false)}
            />
        </Dialog>
    )
}

export default ReportDataDialog
